import { createContext } from 'react';

export type WorkspaceContextType = {
    fileId: string;
    anyChallenges: boolean;
    anyAppraisals: boolean;
    anyChallengesOrAppraisals: boolean;
}

export const WorkspaceContext = createContext<WorkspaceContextType>({
    fileId: '',
    anyAppraisals: false,
    anyChallenges: false,
    anyChallengesOrAppraisals: false
})